/* Theoric · Black 2026 (F1 fixa): contador, aviso do trio/frete no carrinho e regulamento. */
(function () {
  'use strict';
  if (window.TheoricFase) return;

  function safe(fn) {
    return function () {
      try { return fn.apply(this, arguments); } catch (_) {}
    };
  }

  var cfg = {};
  try {
    var el = document.getElementById('theoric-fase-config');
    if (el) cfg = JSON.parse(el.textContent) || {};
  } catch (_) { cfg = {}; }
  function faseAtual() {
    var f = cfg.fase || document.documentElement.getAttribute('data-fase') || 'f1';
    if (f === 'f1' && cfg.fimF1 && Date.now() / 1000 >= Number(cfg.fimF1)) f = 'fim';
    return f;
  }

  var tick = (typeof performance !== 'undefined' && performance.now)
    ? function () { return performance.now(); }
    : function () { return 0; };
  var t0 = tick();
  var baseEpochSec = Number(cfg.agoraServidor) || 0;

  function agoraSec() {
    if (!baseEpochSec) return 0;
    return Math.floor(baseEpochSec + (tick() - t0) / 1000);
  }

  function formatarReais(cents) {
    var n = Math.round(Number(cents) || 0) / 100;
    var partes = n.toFixed(2).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + partes.join(',');
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function atualizarContador() {
    try {
      var wraps = document.querySelectorAll('[data-theoric-contador-wrap]');
      var nos = document.querySelectorAll('[data-theoric-contador]');
      if (!nos.length) return;
      var sec = agoraSec();
      var fimSec = Number(cfg.fimF1) || 0;
      var resto = fimSec - sec;
      if (!fimSec || sec < (Number(cfg.contadorF1) || 0) || resto <= 0) {
        for (var w = 0; w < wraps.length; w++) wraps[w].setAttribute('hidden', '');
        return;
      }
      var d = Math.floor(resto / 86400);
      var h = Math.floor((resto % 86400) / 3600);
      var m = Math.floor((resto % 3600) / 60);
      var txt = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(resto % 60) + 's';
      for (var i = 0; i < nos.length; i++) nos[i].textContent = txt;
      for (var j = 0; j < wraps.length; j++) wraps[j].removeAttribute('hidden');
    } catch (_) {}
  }

  /* ---------- B08: Aviso do trio (F1) e Frete Grátis (F2) no carrinho ---------- */
  var ultimoCartJson = null;
  function renderizarTextoCarrinho(cart) {
    if (!cart) return;
    ultimoCartJson = cart;
    var fase = faseAtual();
    var containers = document.querySelectorAll('[data-theoric-cart-black]');
    if (fase !== 'f1') {
      for (var z = 0; z < containers.length; z++) { containers[z].innerHTML = ''; containers[z].setAttribute('hidden', ''); }
      return;
    }
    var avulsosCount = 0;
    var temKit = false;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var tipo = String(it.product_type || '').toLowerCase();
      var titulo = String(it.product_title || it.title || '').toLowerCase();
      var ehKit = /kit/.test(tipo) || /(^|[- ])kit([- ]|$)/.test(String(it.handle || titulo)) || !!(it.item_components && it.item_components.length);
      if (ehKit) temKit = true;
      if (!ehKit && (!it.properties || it.properties._brinde !== 'true') && it.original_price > 0) {
        avulsosCount += (Number(it.quantity) || 0);
      }
    }
    var totalCents = Number(cart.total_price) || 0;
    var freteMeta = Number(cfg.freteCents) || 49900;
    var faltaFrete = Math.max(0, freteMeta - totalCents);
    var msg = '';

    if (fase === 'f1') {
      var mod = avulsosCount % 3;
      var msgTrio = '';
      if (avulsosCount === 0) {
        msgTrio = '<strong>Black Season:</strong> escolha 3 produtos e o de menor valor sai grátis.';
      } else if (mod === 1) {
        msgTrio = '<strong>Compre 2, leve 3:</strong> adicione mais <strong>2 produtos</strong> e o de menor valor sai grátis.';
      } else if (mod === 2) {
        msgTrio = '<strong>Compre 2, leve 3:</strong> falta <strong>1 produto</strong> para levar 3 e pagar 2!';
      } else {
        var trios = Math.floor(avulsosCount / 3);
        msgTrio = '<strong>Pronto (' + trios + (trios > 1 ? ' trios' : ' trio') + '):</strong> as unidades de menor valor da seleção são elegíveis ao benefício. Confira o desconto aplicado na sacola e no checkout' + '.';
      }
      var msgFreteF1 = faltaFrete > 0
        ? ' Faltam <strong>' + formatarReais(faltaFrete) + '</strong> para frete grátis (contado antes do Pix).'
        : ' O subtotal atual atinge o limite de frete grátis. Confira a condição após os descontos, antes do Pix.';
      msg = msgTrio + msgFreteF1;
    }

    if (temKit) msg = '<strong>Kits fechados não participam da Black.</strong> Remova-os da sacola e escolha os produtos individualmente. ' + msg;
    for (var k = 0; k < containers.length; k++) {
      containers[k].innerHTML = msg;
      containers[k].removeAttribute('hidden');
    }
  }

  function atualizarAvisoCarrinho() {
    try {
      var containers = document.querySelectorAll('[data-theoric-cart-black]');
      if (!containers.length) return;
      if (ultimoCartJson) {
        renderizarTextoCarrinho(ultimoCartJson);
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) renderizarTextoCarrinho(cart); })
        .catch(function () {});
    } catch (_) {}
  }

  function abrirModalRegulamento() {
    document.getElementById('theoric-reg-modal')?.remove();
    var modal = document.getElementById('theoric-reg-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'theoric-reg-modal';
      modal.className = 'theoric-reg-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Regulamento Oficial e Política de Promoção Comercial Black Friday Theoric 2026');
      modal.innerHTML =
        '<div class="theoric-reg-modal__card">' +
          '<button type="button" class="theoric-reg-modal__close" data-reg-close>Fechar ✕</button>' +
          '<p class="theoric-reg-modal__eyebrow">Instrumento Jurídico-Comercial Vinculante · Theoric Cosméticos LTDA (CNPJ 59.628.463/0001-45)</p>' +
          '<h2 class="theoric-reg-modal__title">Regulamento Oficial e Política de Promoção · Black Friday 2026</h2>' +
          '<p class="theoric-reg-modal__meta">Condições da oferta vigente. Horário de Brasília. Kits fechados, brindes e produtos não lançados não participam.</p>' +
          '<div class="theoric-reg-modal__sec">' +
            '<h3>1. Qualificação da Promotora, Abrangência e Conceitos</h3>' +
            '<ul>' +
              '<li><strong>Promotora e Destinatários:</strong> Instituída por <strong>THEORIC COSMÉTICOS LTDA</strong> (CNPJ 59.628.463/0001-45), válida em todo o território nacional exclusivamente em <strong>theoric.com.br</strong> para <strong>Consumidores Finais</strong> (pessoas físicas maiores de 18 anos inscritas no CPF/MF que adquiram para uso próprio/familiar, art. 2º do CDC), vedada a aquisição para revenda comercial.</li>' +
              '<li><strong>Definições Técnicas:</strong> (i) <em>Produto Avulso Elegível:</em> item individual ativo das linhas Haircare, Skincare ou Bodycare com estoque disponível, excetuados Kits de Rotina, brindes e itens ocultos; (ii) <em>Unidade Bonificada:</em> unidade concedida conforme a regra da oferta vigente; (iii) <em>Base de Cálculo Líquida (R$ 499,00):</em> soma dos produtos após os descontos da Black Friday e <strong>antes do desconto de 5% do Pix</strong> e do frete; (iv) <em>Fuso Horário:</em> Horário Oficial de Brasília (BRT / UTC-3).</li>' +
            '</ul>' +
          '</div>' +
          '<div class="theoric-reg-modal__sec">' +
            '<span class="theoric-reg-modal__badge">01/11/2026 às 00h00 até 26/11/2026 às 23h59 (Brasília)</span>' +
            '<h3>2. Black Season · Compre 2, Leve 3</h3>' +
            '<ul>' +
              '<li><strong>Produtos Avulsos ("Compre 2, Leve 3"):</strong> na compra conjunta de 3 (três) Produtos Avulsos Elegíveis no mesmo pedido (iguais ou diferentes), é concedido desconto de <strong>100% sobre a 1 (uma) unidade de menor Preço de Tabela</strong> da seleção elegível. Em múltiplos trios, são bonificadas as unidades globalmente mais baratas, uma a cada três produtos.</li>' +
              '<li><strong>Múltiplos Trios no Mesmo Pedido:</strong> permitida a formação de múltiplos trios (3, 6, 9, 12 avulsos, etc.), bonificando-se 1 unidade para cada grupo completo de 3 avulsos. Unidades avulsas excedentes que não formem múltiplo exato de 3 são cobradas pelo Preço de Tabela normal.</li>' +
            '</ul>' +
          '</div>' +
          '<div class="theoric-reg-modal__sec">' +
            '<h3>3. Frete Grátis, Base de Cálculo de R$ 499,00, Pix (Lei 13.455/2017) e Cupons</h3>' +
            '<ul>' +
              '<li><strong>Frete Grátis a partir de R$ 499,00:</strong> válido durante a Black Season na modalidade de envio padrão (econômica/convencional).</li>' +
              '<li><strong>Regra da Base de Cálculo dos R$ 499,00:</strong> aferida sobre o subtotal líquido dos produtos <strong>após os descontos da Black Friday e ANTES do desconto de 5% do Pix</strong>. <em>Exemplo:</em> pedido de R$ 500,00 após descontos da Black que cai para R$ 475,00 no Pix (-5%) <strong>mantém integralmente</strong> o Frete Grátis.</li>' +
              '<li><strong>Pix 5% OFF Cumulativo e Cartão em 6x:</strong> o desconto de 5% no Pix (Lei nº 13.455/2017) acumula com o Compre 2, Leve 3. Cartão de crédito em até 6x sem juros (respeitada a parcela mínima).</li>' +
              '<li><strong>Suspensão e Não Cumulatividade de Cupons:</strong> de 01/11 a 26/11/2026, cupons de primeira compra (<code>CELEBRE10</code>), influenciadores, parcerias e CRM ficam suspensos e não se acumulam com a Campanha.</li>' +
            '</ul>' +
          '</div>' +
          '<div class="theoric-reg-modal__sec">' +
            '<h3>4. Irretroatividade, Reserva de Estoque, Devoluções (Art. 49 CDC) e Antifraude</h3>' +
            '<ul>' +
              '<li><strong>Irretroatividade e Estoque:</strong> as condições de uma oferta não alteram retroativamente pedidos anteriores. A inserção na sacola não garante reserva de estoque, que ocorre apenas após a aprovação do pagamento.</li>' +
              '<li><strong>Arrependimento (Art. 49 CDC) e Devolução Parcial:</strong> em até 7 dias corridos do recebimento, a devolução integral exige todos os itens e Unidades Bonificadas lacrados e sem uso (normas sanitárias ANVISA). Na devolução parcial voluntária que desfaça o trio ("Compre 2, Leve 3"), o reembolso é recalculado deduzindo-se o Preço de Tabela das unidades retidas pelo Consumidor.</li>' +
              '<li><strong>Prevenção a Fraudes e Foro:</strong> a THEORIC poderá cancelar pedidos com indícios de fraude, revenda não autorizada, abuso sistêmico de CPF ou erro crasso de preço, mediante estorno integral. Proteção de dados regida pela LGPD (Lei nº 13.709/2018) e foro do domicílio do Consumidor (art. 101, I, do CDC).</li>' +
            '</ul>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (ev) {
        if (ev.target === modal || ev.target.closest('[data-reg-close]')) {
          modal.setAttribute('hidden', '');
        }
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !modal.hasAttribute('hidden')) {
          modal.setAttribute('hidden', '');
        }
      });
    }
    modal.removeAttribute('hidden');
    modal.querySelector('[data-reg-close]').focus();
  }

  function abrirPopupComunidade() {
    var pop = document.querySelector('[data-tcm-popup]');
    if (!pop) return;
    pop.classList.remove('is-joined', 'is-sending');
    pop.hidden = false;
    document.documentElement.classList.add('tcm-lock');
    void pop.offsetWidth;
    pop.classList.add('is-open');
    if (!pop.dataset.theoricPopupBound) {
      pop.dataset.theoricPopupBound = '1';
      pop.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-tcm-close]') || ev.target === pop || ev.target.hasAttribute('data-tcm-backdrop')) {
          pop.classList.remove('is-open');
          document.documentElement.classList.remove('tcm-lock');
          setTimeout(function () {
            if (!pop.classList.contains('is-open')) pop.hidden = true;
          }, 260);
        }
      });
    }
  }

  function iniciar() {
    atualizarContador();
    atualizarAvisoCarrinho();
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="regulamento-black"]') : null;
      if (a && !document.querySelector('.theoric-black-regulamento-section')) {
        ev.preventDefault();
        abrirModalRegulamento();
      }
    });
    try {
      if (location.search.indexOf('regulamento=1') > -1 || location.hash === '#regulamento-black') {
        abrirModalRegulamento();
      }
      if (location.search.indexOf('popup=1') > -1 || location.hash === '#popup-black') {
        setTimeout(function () { abrirPopupComunidade(); }, 180);
      }
    } catch (_) {}
    setInterval(safe(function () {
      atualizarContador();
    }), 1000);
  }

  window.TheoricFase = {
    fase: faseAtual(),
    freteCents: Number(cfg.freteCents) || 49900,
    pixPct: Number(cfg.pixPct) || 5,
    teste: false,
    agoraSec: agoraSec,
    setFase: function () {},
    atualizarCarrinho: atualizarAvisoCarrinho,
    abrirRegulamento: abrirModalRegulamento,
    abrirPopup: abrirPopupComunidade
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safe(iniciar));
  } else {
    safe(iniciar)();
  }
})();

